import React, { Fragment } from 'react'
import Tooltip from 'react-tooltip-lite'

const Item = props => {
    const { id, title, extraInfo, currentPageId, handleChangeChild } = props

    const content = extraInfo ? (
        <Fragment>
            <span>{title}</span>
            <br />
            <span className="text-sm">{extraInfo}</span>
        </Fragment>
    ) : (
        title
    )

    return (
        <div id={id === currentPageId ? 'active' : ''}>
            <Tooltip content={content}>
                {id === currentPageId ? (
                    <div className="h-10 mx-3 px-2 border-b-4 pt-2 font-semibold border-white cursor-pointer">
                        {title}
                    </div>
                ) : (
                    <div
                        className="h-10 mx-3 pt-2 cursor-pointer"
                        onClick={e => {
                            e.preventDefault()
                            handleChangeChild(id)
                        }}
                    >
                        {title}
                    </div>
                )}
            </Tooltip>
        </div>
    )
}

export default Item
